/** @format */

import { TableToolbar, TableToolbarContent, TableToolbarSearch } from "@carbon/react";
import { NullableTableColumns } from "@flaminem/ui-components";
import React, { useState } from "react";

import { FixedTable } from "src/components/Tables/FixedTable.tsx";
import { defaultPageSize, defaultRowHeight } from "src/config/table-config.ts";
import { useT } from "src/internationalization";
import { RuleWithScore } from "src/pages/Scenarios/Scenarios.types.ts";

import { searchForRule } from "../searchForRule";

type ScenarioRulesTableProps = {
  rules: RuleWithScore[] | undefined | null;
};

const ScenarioRulesTable: React.FC<ScenarioRulesTableProps> = ({ rules }) => {
  const [search, setSearch] = useState("");
  const t = useT();

  const columns: NullableTableColumns<RuleWithScore> = {
    name: {
      label: t("general.table.name.column.title"),
      render: (rule) => rule.name,
      width: 100,
      flexBasis: 100,
      flexGrow: 2,
      flexShrink: 1,
    },
    code: {
      label: t("general.table.code.column.title"),
      render: (rule) => rule.code,
      width: 100,
      flexBasis: 100,
      flexGrow: 2,
      flexShrink: 1,
    },
    description: {
      label: t("general.table.description.column.title"),
      render: (rule) => rule.description,
      width: 100,
      flexBasis: 100,
      flexGrow: 2,
      flexShrink: 1,
    },
    score: {
      label: t("rules.table.score.column.title"),
      render: (rule) => rule.score,
      width: 50,
      flexBasis: 50,
      flexGrow: 1,
      flexShrink: 2,
    },
  };

  return (
    <FixedTable
      id="scenarioVersionRules"
      data={rules ?? []}
      title={t("rules.title")}
      description={t("rules.description")}
      pageSize={defaultPageSize}
      columns={columns}
      rowHeight={defaultRowHeight}
      isLoading={false}
      filter={(rule) => searchForRule(search, rule)}
      toolbar={() => (
        <TableToolbar aria-label="data table toolbar">
          <TableToolbarContent className="border-b border-solid border-borderSubtle01">
            <TableToolbarSearch
              placeholder={t("page.rules.table.search.placeholder")}
              persistent={true}
              onChange={(e) => {
                if (typeof e === "string") {
                  setSearch(e);
                  return;
                }

                if (e.target instanceof HTMLInputElement) {
                  setSearch(e.target.value);
                }
              }}
              value={search}
            />
          </TableToolbarContent>
        </TableToolbar>
      )}
    />
  );
};

export default ScenarioRulesTable;
